import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

const MenuIcon = ({ icon, style }) => (
  <i className={`two-key-icon ${icon}`} style={style} />
);

MenuIcon.propTypes = {
  icon: PropTypes.string,
  style: PropTypes.object,
};

export default MenuIcon;
